import React from 'react';

import { useEFM } from '../Ajax';

export default function useGetPendingPermissionRequests() {
	return useEFM('/application/permission/pending-requests');
}
